import React, { Fragment, useState, useEffect } from "react";
import "./pactometro.scss";
import {
  ResultProvider,
  getResultOrigin,
  TYPES,
  SUBTYPES,
  PactometroCheck,
  PactometroCheckSimple
} from "@atresmedia/elections_modules_library";
import cintillos from "../../components/cintillo/cintillos";

const PACTOMETRO_A3 = "CALCULADORA DE PACTOS";
const PACTOMETRO_L6 = "PACTÓMETRO";
const PACTOMETRO_OC = "PACTOS";

const Pactometro = ({ match, simple }) => {
  const { year, type, electionNumber, placesIds, community } = match.params;

  const [resultOrigin, setResultOrigin] = useState({});

  useEffect(() => {
    getResultOrigin(
      year,
      type,
      electionNumber,
      type === TYPES.REGIONAL ? community : placesIds
    )
      .then(historicResult => {
        setResultOrigin(historicResult);
      })
      .catch(err => {});
  }, [year, type, electionNumber, placesIds, community]);
  const CurrentCintillo = cintillos[community];
  const site =
    match.params.site ||
    window.location.hostname.replace("localhost", "lasexta");
  return (
    <div>
      <div className="pagePactometro">
        {CurrentCintillo && (
          <CurrentCintillo
            rightSide={
              site.indexOf("lasexta") === -1
                ? site.indexOf("ondacero") === -1
                  ? PACTOMETRO_A3
                  : PACTOMETRO_OC
                : PACTOMETRO_L6
            }
          ></CurrentCintillo>
        )}
        {resultOrigin && resultOrigin.primary && (
          <ResultProvider
            electionPlace={type === TYPES.REGIONAL ? community : placesIds}
            active={resultOrigin.primary.active}
            year={year}
            type={type}
            subtype={
              type === TYPES.GENERAL ? SUBTYPES.CONGRESS : SUBTYPES.SINGLE
            }
            electionNumber={electionNumber}
            placeId={type === TYPES.REGIONAL ? community : placesIds}
          >
            {dataResult =>
              dataResult.partiesResult && dataResult.totalSeats ? (
                simple ? (
                  <PactometroCheckSimple
                    seatData={dataResult.partiesResult}
                    totalSeat={dataResult.totalSeats}
                  />
                ) : (
                  <PactometroCheck
                    seatData={dataResult.partiesResult}
                    totalSeat={dataResult.totalSeats}
                  />
                )
              ) : (
                <p>Cargando</p>
              )
            }
          </ResultProvider>
        )}
      </div>
    </div>
  );
};

export default Pactometro;
